import { useState } from "react";
import {
  Heading, Box, Text, Center, Tooltip, Flex, useColorMode,
  Link,
} from "@chakra-ui/react";
import PuffLoader from "react-spinners/PuffLoader";
import { QuestionIcon } from "@chakra-ui/icons";
// import Image from 'next/legacy/image';
import { ImageNextChakra } from 'components/common/image-next-chakra';
import { textStyle } from "theme/names";

export function Engagers({
  account,
  isLoading = false,
}) {
  const [index, setIndex] = useState(null);
  const [hoveredPoint, setHoveredPoint] = useState<any>();
  const [data, setData] = useState<any>([]);

  return (
    <Box>
      <Flex justifyContent="center">
        <Heading fontSize="xl" color="#656565">
          Who is engaging with {account?.firstName}
        </Heading>
        <Tooltip
          hasArrow
          label={
            <>
              <Text>
                We look at who is engaging with {account?.firstName} so you can
                find the people who are most interested in {account?.firstName}
                's content.
              </Text>
            </>
          }
        >
          <QuestionIcon color="gray.400" mt={1} ml={2} />
        </Tooltip>
      </Flex>
      {!isLoading && account?.engagers?.length <= 0 && (
        <Text
          textStyle={textStyle["body.medium.light"]}
          p="8"
          textAlign="center"
        >
          No chart data found. Please try a different timeframe
        </Text>
      )}
      {isLoading && (
        <Center pt={10}>
          <PuffLoader
            color={"#09527c"}
            loading={isLoading}
            cssOverride={{
              display: "block",
              margin: "0 auto",
              borderColor: "red",
            }}
            size={50}
          />
        </Center>
      )}
      {!isLoading && (
        <Center>
          <Flex
            position="relative"
            maxW="600px"
            wrap="wrap"
            p={10}
            justifyContent="center"
          >
            {account?.engagers?.slice(0, 45).map((user, index) => (
              <Box m={1} h="12" w="12">
                <Link
                  href={"https://taplio.com/lookup/" + user.username}
                  target="_blank"
                >
                  <Tooltip label={user.firstName + " " + user.lastName}>
                    <Box w="48px" h="48px" rounded="full" overflow="hidden">
                      <ImageNextChakra
                        width={48}
                        height={48}
                        src={user.profileImage}
                        alt={
                          user.firstName +
                          " " +
                          user.lastName +
                          " profile picture"
                        }
                        fallbackSrc="/emptyProfile.png"
                        isSwitchToAvatar={true}
                        unoptimized={"true"}
                      />
                    </Box>
                  </Tooltip>
                </Link>
              </Box>
            ))}
          </Flex>
        </Center>
      )}
    </Box>
  );
}
